// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"822d691c","201":"5f0a24e6","243":"f5487874","376":"2669c317","470":"534a7be7","814":"c31f1340","980":"96c60687"}[chunkId] + ".chunk.js";
};